import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {Layers, RockBottomLayers} from "../view/RockBottomLayers";
import {RockBottom} from "../RockBottom";
import {RockBottomGameMode} from "../server/RockBottomGameMode";
import {RockBottomSound} from "../sound/RockBottomSound";
import {RockBottomParsedGameData} from "../server/data/RockBottomParsedGameData";
import {RockBottomParsedInitData} from "../server/data/RockBottomParsedInitData";
import {RockBottomGameAssets} from "../RockBottomGameAssets";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {RockBottomFreeSpinView} from "../view/RockBottomFreeSpinView";
import {gsap, TimelineLite, TweenLite} from "gsap";
import {RockBottomGameConfig} from "../RockBottomGameConfig";

export class FreespinIntro extends ContinueScreen {
    private _spinsCounter: PIXI.BitmapText;
    private _overlay: PIXI.Graphics;
    private _fsIntroSpine: PIXI.spine.Spine;
    private _sfsIntroSpine: PIXI.spine.Spine;

    constructor() {
        super(RockBottomLayers.getLayer(Layers.SCREENS)!);
        this.init();
        this.onResize();
    }

    public show(onContinueCallBack: () => void): void {
        super.show(onContinueCallBack);
        this._continueButton.visible = false;
        const parsedData: RockBottomParsedInitData | RockBottomParsedGameData = RockBottom.getParsedData(),
            nextMode: RockBottomGameMode = parsedData.nextMode;

        RockBottomSound.soundPlayer.stopTrack(RockBottomSound.MAIN_GAME_MUSIC);
        RockBottomSound.playTrack(RockBottomSound.BONUS_INITIAL_IMPACT);

        //#224 fail safe check
        if (!(parsedData.isRestoreState)) {
            for (let reelId: number = 2; reelId < RockBottomGameConfig.REELS_NUM; reelId++) {
                RockBottom.anticipationView.toggleScatterAnticipation(reelId, false);
            }
            RockBottom.reelBg.onAnticipation(false);
        }

        if (!RockBottom.model.isRestore) {
            if (parsedData.nextMode === RockBottomGameMode.FREESPIN) {
                RockBottomSound.playTrack(RockBottomSound.FS_INTRO_TEXT_SOUND);
                RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.FS_INTRO_VOICE});
                RockBottomSound.soundPlayer.playTrack({
                    name: RockBottomSound.FREESPIN_INTRO_MUSIC,
                    repeat: Number.MAX_VALUE
                });
            } else if (parsedData.nextMode === RockBottomGameMode.SUPER_FREESPIN) {
                RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.SFS_INTRO_VOICE});
                RockBottomSound.soundPlayer.playTrack({
                    name: RockBottomSound.SUPER_FREESPIN_INTRO_MUSIC,
                    repeat: Number.MAX_VALUE
                });
            }
        }
        if (RockBottom.model.isRestore && (nextMode === RockBottomGameMode.FREESPIN || (parsedData.mode === RockBottomGameMode.FREESPIN && parsedData.nextMode !== RockBottomGameMode.WINCAP_PICK))) {
            RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.FS_INTRO_VOICE});
            RockBottomSound.soundPlayer.playTrack({
                name: RockBottomSound.FREESPIN_INTRO_MUSIC,
                repeat: Number.MAX_VALUE
            });
        } else if (RockBottom.model.isRestore && (nextMode === RockBottomGameMode.SUPER_FREESPIN || (parsedData.mode === RockBottomGameMode.SUPER_FREESPIN && parsedData.nextMode !== RockBottomGameMode.WINCAP_PICK))) {
            RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.SFS_INTRO_VOICE});
            RockBottomSound.soundPlayer.playTrack({
                name: RockBottomSound.SUPER_FREESPIN_INTRO_MUSIC,
                repeat: Number.MAX_VALUE
            });
        }

        this.playSpineAnim();
        this._overlay.visible = true;
        this._spinsCounter.text = (parsedData.freespinsLeft).toString();
        this._spinsCounter.pivot.set(this._spinsCounter.width / 2, this._spinsCounter.height / 2);
        RockBottom.freeSpinView.showView();
        if (RockBottom.isBoostedBetAllowed()) {
            RockBottom.xBetView.toggleXBetFlushAnim(false);
            //const xBetBtn: RockBottomXBetButton = RockBottom.xBetView.getXBetButton();
            //xBetBtn.switchOnBonusGame(false);
        }

    }

    protected close(): TimelineLite {
        const parsedData: RockBottomParsedInitData | RockBottomParsedGameData = RockBottom.getParsedData();
        if (parsedData.nextMode === RockBottomGameMode.FREESPIN) {
            RockBottomSound.soundPlayer.stopTrack(RockBottomSound.FS_INTRO_VOICE);
            RockBottomSound.soundPlayer.stopTrack(RockBottomSound.FREESPIN_INTRO_MUSIC);
        } else if (parsedData.nextMode === RockBottomGameMode.SUPER_FREESPIN) {
            RockBottomSound.soundPlayer.stopTrack(RockBottomSound.SFS_INTRO_VOICE);
            RockBottomSound.soundPlayer.stopTrack(RockBottomSound.SUPER_FREESPIN_INTRO_MUSIC);
        }
        RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.CONTINUE_BUTTON_BONUS_INTRO});
        if (parsedData.nextMode === RockBottomGameMode.FREESPIN || parsedData.nextMode === RockBottomGameMode.SUPER_FREESPIN) {
            RockBottomFreeSpinView.freespinSounds(parsedData.fsLevel);
        }

        RockBottom.setBonusMode(true);
        RockBottom.background.updateBackGround(RockBottomGameMode.FREESPIN);
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            TweenLite.to(this, {
                duration: 0.3,
                alpha: 0,
                onComplete: () => {
                    RockBottom.keypadPlugin.show();
                    this.visible = false;
                    this.alpha = 1;
                    this._continueButton.visible = false;
                    this._overlay.alpha = 0;
                    this._spinsCounter.alpha = 0;
                    this._overlay.visible = false;
                    this.resetSpine(this._fsIntroSpine);
                    this.resetSpine(this._sfsIntroSpine);
                    this._spinsCounter.position.set(680, 100);
                    RockBottom.background.updateLevelUpTint(true);
                    this._spinsCounter.scale.set(RockBottomGameConfig.SPINS_COUNT_SCALE);
                }
            });
        });
        return tl;
    }

    private playSpineAnim(): void {
        const parsedData: RockBottomParsedInitData | RockBottomParsedGameData = RockBottom.getParsedData(),
            nextMode: RockBottomGameMode = parsedData.nextMode,
            isFS: boolean = nextMode === RockBottomGameMode.FREESPIN,
            spineToPlay: PIXI.spine.Spine = isFS ? this._fsIntroSpine : this._sfsIntroSpine,
            introName: string = parsedData.freespinsLeft === 1 ? "Intro_Spin" : "Intro",
            introAnimDur: number = spineToPlay.skeleton.data.findAnimation(introName).duration,
            loopName: string = parsedData.freespinsLeft === 1 ? "Loop_Spin" : "Loop",
            loopAnimDur: number = spineToPlay.skeleton.data.findAnimation(loopName).duration,
            tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this, {
            duration: introAnimDur,
            onStart: () => {
                TweenLite.to(this._overlay, {
                    alpha: 1,
                    duration: 0.3
                });
                this.resetSpine(spineToPlay);
                spineToPlay.visible = true;
                spineToPlay.state.setAnimation(0, introName, false);
                TweenLite.to(this._spinsCounter, {
                    duration: 0.2,
                    alpha: 1,
                    delay: 0.5
                });
                TweenLite.to(this._spinsCounter.position, {
                    duration: parsedData.isRestoreState ? 0 : 0.2,
                    x: 360,
                    y: 140,
                    delay: parsedData.isRestoreState ? 0 : 0.5
                });
                TweenLite.to(this._spinsCounter.pivot, {
                    duration: parsedData.isRestoreState ? 0 : 0.2,
                    x: this._spinsCounter.width / 2,
                    y: this._spinsCounter.height / 2,
                    delay: parsedData.isRestoreState ? 0 : 0.5
                });
                TweenLite.to(this._spinsCounter.scale, {
                    duration: parsedData.isRestoreState ? 0 : 0.2,
                    x: 1,
                    y: 1,
                    delay: parsedData.isRestoreState ? 0 : 0.5
                });
            },
            onComplete: () => {
                this._continueButton.visible = true;
                if (isFS) {
                    spineToPlay.state.setAnimation(0, loopName, true);
                } else {
                    const repeatTimes: number = 2
                    for (let i: number = 0; i < repeatTimes; i++) {
                        spineToPlay.state.addAnimation(0, loopName, false, loopAnimDur);
                    }
                }
            }
        });
    }

    private resetSpine(currSpine: PIXI.spine.Spine): void {
        currSpine.skeleton.setToSetupPose();
        currSpine.updateTransform();
        currSpine.visible = false;
    }

    private init(): void {
        this.createOverlay();
        this.createFSIntroSpine();
        this.createSFSIntroSpine();
        this.createSpinsCountText();
    }

    private createFSIntroSpine(): void {
        this._fsIntroSpine = this.createSpine("FS_intro");
        this._container.addChild(this._fsIntroSpine);
    }

    private createSFSIntroSpine(): void {
        this._sfsIntroSpine = this.createSpine("SFS_intro");
        this._container.addChild(this._sfsIntroSpine);
    }

    private createSpine(name: string): PIXI.spine.Spine {
        const spineObj: PIXI.spine.Spine = new PIXI.spine.Spine(RockBottom.assetLoader.getSpineAsset(name));
        spineObj.position.set(360);
        spineObj.visible = false;
        spineObj.name = name;
        return spineObj;
    }

    private createSpinsCountText(): void {
        this._spinsCounter = new PIXI.BitmapText("", {
            fontName: RockBottomGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 30,
            letterSpacing: -30
        });
        this._spinsCounter.alpha = 0;
        this._spinsCounter.pivot.set(this._spinsCounter.width / 2, this._spinsCounter.height / 2);
        this._spinsCounter.position.set(680, 100);
        this._spinsCounter.scale.set(RockBottomGameConfig.SPINS_COUNT_SCALE);
        this._container.addChild(this._spinsCounter);
    }

    private createOverlay(): void {
        this._overlay = new PIXI.Graphics;
        this._overlay.alpha = 0;
        this._overlay.beginFill(0x000000, 1);
        this._overlay.drawRect(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top, NolimitApplication.screenBounds.width, NolimitApplication.screenBounds.height);
        this._overlay.endFill();
        this._overlay.visible = false;
        this._container.addChild(this._overlay);
    }

    private onResize(): void {
        if (this._overlay) {
            this._overlay.clear();
            this._overlay.beginFill(0x000000, 1);
            this._overlay.drawRect(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top, NolimitApplication.screenBounds.width, NolimitApplication.screenBounds.height);
            this._overlay.endFill();
        }
    }
}